// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2Jz3y","loaderChild":"Loader_loaderChild__3MR02","spinRipple":"Loader_spinRipple__1SfT3","loaderSecondChild":"Loader_loaderSecondChild__2AcCZ"};